import React, { useState } from "react";
import ToastMessage from "../utils/mui/righttoptoast";
import api from "../api/api";
import { getPracticeId } from "../config/practice";


const StatusModal = ({ ismodal, setisModal, rowId, getdetails }) => {  
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [checkedStatus, setCheckedStatus] = useState(null);
  const practiseid = getPracticeId();

  if (!ismodal) return null;

  const handleCloseToast = () => setOpenToast(false);

  const handleRadioChange = (name) => {
    setCheckedStatus(name); // Directly set the value of the selected option
  };

    const handleSave = async () => {
    if (checkedStatus) {
      try {
         const response = await api.get(`/v1/${practiseid}/onboarding/${rowId}/statusupdate/${checkedStatus}`);
       
        if (response.status === 200) {
          console.log("Status updated successfully!");
          setToastMessage(response.message || "Status updated successfully!");
          setToastSeverity("success");
          setOpenToast(true);
          setisModal(false);
          getdetails();
        }
      } catch (error) {
        // Handle error if needed (e.g., show a notification)
        console.log("Error updating status. Please try again.");
      }
    } else {
      alert("Please select a status before applying.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
      <div className="w-full max-w-md rounded-[8px] bg-white shadow-[0px_10px_15px_-3px_rgba(0,0,0,0.10),0px_4px_6px_-4px_rgba(0,0,0,0.10)] p-6">
        {/* Header */}
        <div className="text-left text-lg font-medium pb-4 border-b border-gray-200">
          Change Status
        </div>

        {/* Custom Radio Buttons */}
        <div className="py-4 space-y-3">
          {[ 
            { label: "Unread", key: "1" },
            { label: "Archive", key: "2" },
            { label: "Needs Call Back", key: "3" }
          ].map((item) => (
            <label key={item.key} className="flex items-center gap-3 text-[#364153] cursor-pointer">
              <input
                type="radio"
                name="status" // Same name ensures only one can be selected
                checked={checkedStatus === item.key} // Compare with the current selected value
                onChange={() => handleRadioChange(item.key)} // Update the state on change
                className="hidden peer"
              />
              <div className="w-5 h-5 rounded-full border-[0.2px] border-[#767676] flex items-center justify-center">
                <div
                  className={`w-2.5 h-2.5 rounded-full bg-black transition ${
                    checkedStatus === item.key ? "opacity-100" : "opacity-0"
                  }`}
                />
              </div>
              <span>{item.label}</span>
            </label>
          ))}
        </div>

        {/* Footer Buttons */}
        <div className="flex justify-end gap-3 pt-4">
          <button
            onClick={() => setisModal(false)}
            className="rounded-md border border-gray-300 px-4 py-2 text-sm"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="rounded-md bg-black text-white px-4 py-2 text-sm"
          >
            Apply
          </button>
        </div>
      </div>
     {/* TOAST */}
      <ToastMessage
        message={toastMessage} 
        severity={toastSeverity} 
        open={openToast} 
        handleClose={handleCloseToast} 
      />
    </div>
  );
};

export default StatusModal;